import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getDeployedModel } from '../services/api';
import { API_BASE_URL } from '../services/config';
import '../styles/ManageModel.css';

const ModelDeployment = () => {
  const [models, setModels] = useState([]);
  const [loading, setLoading] = useState(false);
  const [copiedEndpointId, setCopiedEndpointId] = useState(null);
  const [loadingStates, setLoadingStates] = useState({
    card: {},
    evaluation: {},
    temination: {},
  });

  const fetchData = async () => {
    const token = localStorage.getItem('adminToken');
    setLoading(true);
    try {
      const res = await getDeployedModel(token);
      setModels(res);
    } catch (error) {
      console.error('Error fetching models:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleCopyEndpoint = async (model) => {
    try {
      await navigator.clipboard.writeText(model.endpoint);
      setCopiedEndpointId(model.id);
      setTimeout(() => setCopiedEndpointId((prev) => (prev === model.id ? null : prev)), 1500);
    } catch (error) {
      console.error('Error copying endpoint:', error);
      alert('Failed to copy endpoint.');
    }
  };

  const handleDownloadModelData = (filePath, modelname, fileType, modelId, setLoadingState) => {
    setLoadingState(true);
    const token = localStorage.getItem('adminToken');
    axios
      .post(`${API_BASE_URL}/get-model-data`, { filePath }, { headers: { Authorization: `Bearer ${token}` } })
      .then((response) => {
        setLoadingState(false);
        if (response.data.success) {
          const fileURL = window.URL.createObjectURL(new Blob([response.data.data], { type: 'text/html' }));
          const link = document.createElement('a');
          link.href = fileURL;
          link.setAttribute('download', `${modelname}_${fileType}.html`);
          document.body.appendChild(link);
          link.click();
        } else {
          alert(response.data.message || `Error downloading ${fileType}.`);
        }
      })
      .catch((error) => {
        setLoadingState(false);
        console.error(`Error fetching ${fileType}:`, error);
        alert(`Error fetching ${fileType}.`);
      });
  };

  const handleDownloadModelCard = (model) => {
    handleDownloadModelData(model.model_card, model.modelname, 'model_card', model.id, (state) =>
      setLoadingStates((prev) => ({
        ...prev,
        card: { ...prev.card, [model.id]: state },
      }))
    );
  };

  const handleDownloadModelEvaluation = (model) => {
    handleDownloadModelData(model.model_evaluation, model.modelname, 'model_evaluation', model.id, (state) =>
      setLoadingStates((prev) => ({
        ...prev,
        evaluation: { ...prev.evaluation, [model.id]: state },
      }))
    );
  };


  const handleModelTermination = async (model) => {
    if (!window.confirm(`Terminate model "${model.modelname}" (v${model.version})? This cannot be undone.`)) {
      return;
    }
    try {
      setLoadingStates((prev) => ({
        ...prev,
        temination: { ...prev.temination, [model.id]: true },
      }));

      const token = localStorage.getItem('adminToken');
      const adminId = localStorage.getItem('adminId');
      const user = {
        user_id: adminId,
        user_name: 'admin',
        user_email: '',
        api_key: '',
        user_role: ['admin'],
      };

      const modelData = {
        "modelname": model.modelname,
        "version": model.version,
        "endpoint": model.endpoint,
        "user_detail": user,
      }

      axios.post(`${API_BASE_URL}/model_deployment/terminate`,
        modelData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      ).then((response) => {
        setLoadingStates((prev) => ({
          ...prev,
          temination: { ...prev.temination, [model.id]: false },
        }));
        if (response.status === 200) {
          alert(`Model Termination For Model ${model.modelname} Successfull.`)
        } else {
          alert(`Model Termination for Model ${model.modelname} Failed. Reason :- ${response.data.message}`)
        }
        fetchData()
      }).catch((error) => {
        setLoadingStates((prev) => ({
          ...prev,
          temination: { ...prev.temination, [model.id]: false },
        }));
        alert(error)
      })
    } catch (error) {
      setLoadingStates((prev) => ({
        ...prev,
        temination: { ...prev.temination, [model.id]: false },
      }));

      alert(error)
    }
  };


  return (
    <div className="model-management-wrapper model-deployment">
      <div className="model-header">
        <h1>Deployed Models</h1>
      </div>

      {loading ? (
        <div className="loading-message">Loading models...</div>
      ) : models.length === 0 ? (
        <div className="empty-message">No deployed models found</div>
      ) : (
        <div className="model-table-wrapper">
          <table className="model-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Model Name</th>
                <th>Version</th>
                <th>Image Name</th>
                <th>Endpoint</th>
                <th>Instance ID</th>
                <th>User Name</th>
                <th>Active</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {models.map((model) => (
                <tr key={model.id}>
                  <td>{model.id}</td>
                  <td className="model-name">{model.modelname}</td>
                  <td className="model-version">
                    <span className="version-badge">v{model.version}</span>
                  </td>
                  <td className="truncate-cell" title={model.imagename}>{model.imagename}</td>
                  <td className="endpoint-cell">
                    <span className="truncate-cell" title={model.endpoint}>{model.endpoint}</span>
                    <button
                      onClick={() => handleCopyEndpoint(model)}
                      className="copy-endpoint-button"
                      title="Copy endpoint"
                    >
                      {copiedEndpointId === model.id ? 'Copied' : 'Copy'}
                    </button>
                  </td>
                  <td className="truncate-cell" title={model.instance_id}>{model.instance_id}</td>
                  <td>{model.user_name || 'User not available'}</td>
                  <td className="active-col">
                    {model.active ? (
                      <span className="badge-yes">Yes</span>
                    ) : (
                      <span className="badge-no">No</span>
                    )}
                  </td>
                  <td className="action-buttons">
                    <button
                      onClick={() => handleDownloadModelCard(model)}
                      disabled={loadingStates.card[model.id]}
                      className="action-button card-button"
                      title="Download Model Card"
                    >
                      {loadingStates.card[model.id] ? '...' : 'Card'}
                    </button>
                    <button
                      onClick={() => handleDownloadModelEvaluation(model)}
                      disabled={loadingStates.evaluation[model.id]}
                      className="action-button evaluation-button"
                      title="Download Model Evaluation"
                    >
                      {loadingStates.evaluation[model.id] ? '...' : 'Evaluation'}
                    </button>
                    <button
                      onClick={() => handleModelTermination(model)}
                      disabled={loadingStates.temination[model.id]}
                      className="action-button terminate-button"
                      title="Terminate Model"
                    >
                      {loadingStates.temination[model.id] ? '...' : 'Terminate'}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ModelDeployment;
